import { defineStore } from "pinia";
import autoretService from "@/services/Autoret/autoret.service";

export const useAutorStore = defineStore("autoreStore", {
  state: () => ({
    loading: false,
    error: null,
    autoret: [],
    kryesuesit: [],
    zevendeskryesuesit: [],
    ishkryesuesit: [],
    ishzevendeskryesuesit: [],
    antertkshillit: [],
    antertkshillitKryesuesi: [],
    antaretkomunal: [],
    antaretadministrata: [],
    kryeprokurori: [],
    ishKryeprokuri: [],
    zevndesKryeprokuri: [],
    prokuroeret: [],
    departamenitkrimeTeRenda: [],
    deparatamentiPergjitheshem: [],
    deparatamentiTeMitur: [],
    departamenitkrimeTeLuftes: [],
    deparatamentiHetimKrimeOrganizuara: [],
    departamenitHetimETerorizimit: [],
    deparatamentiKorrupcionFinancaiar: [],
    kordinatoret: [],
    administrata: [],

    zyraEdrejtorit: [],
    administrataEProkurorise: [],
  }),

  actions: {
    formatDate(dateString) {
      if (!dateString || typeof dateString !== "string") {
        return "Data e pavlefshme";
      }
      let date;
      // Check if the date is in DD-MM-YYYY format
      const ddmmyyyyMatch = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (ddmmyyyyMatch) {
        const [, day, month, year] = ddmmyyyyMatch;
        date = new Date(`${year}-${month}-${day}`);
      } else {
        // Try parsing as-is (e.g., ISO format)
        date = new Date(dateString);
      }

      if (isNaN(date.getTime())) {
        return "Data e pavlefshme";
      }

      return date.toLocaleDateString("sq-AL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    async getKryesuesit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1; // Move null/undefined to the end
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location); // Numerical sorting
          });

        return (this.kryesuesit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getZevendeskryesuesit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.zevendeskryesuesit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getIshkryesuesit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.ishkryesuesit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getIshZevendeskryesuesit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.ishzevendeskryesuesit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getAntaretkshillitKryesuesi(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.categoryName,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.antertkshillitKryesuesi = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getAntaretkshillit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.categoryName,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.antertkshillit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getAntaretadministrata(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.categoryName,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.antaretadministrata = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getProkuroret(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.autoret = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getKryeProkuroret(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.kryeprokurori = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getIShKryeProkuroret(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.ishKryeprokuri = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getZavendesKryeProkuroret(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.zevndesKryeprokuri = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getProkuroretLista(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.prokuroeret = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDeparmentiKrimeTeRenda(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.departamenitkrimeTeRenda = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDeparmentiTeMitur(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.deparatamentiTeMitur = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDeparmentiPergjitheshem(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.deparatamentiPergjitheshem = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDepartamenitkrimeTeLuftes(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.departamenitkrimeTeLuftes = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDeparatamentiHetimKrimeOrganizuara(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.deparatamentiHetimKrimeOrganizuara = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDepartamenitHetimETerorizimit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.departamenitHetimETerorizimit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getDeparatamentiKorrupcionFinancaiar(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.deparatamentiKorrupcionFinancaiar = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getKordinatoret(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.kordinatoret = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getZyrjDrejtorit(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.zyraEdrejtorit = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getAdministratoret(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.administrata = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getAdministratoreteProkurorive(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await autoretService.getAutoret(data);

        const sorted = response
          .map((autor) => ({
            id: autor.id,
            title: autor.title,
            firstName: autor.firstName,
            lastName: autor.lastName,
            email: autor.email,
            officialEmail: autor.officialEmail,
            phone: autor.phone,
            address: autor.address,
            birthdate: this.formatDate(autor.birthdate),
            location: autor.location,
            description: autor.description,
            language: autor.language,
            published: autor.published,
            cvUrl: autor.cvUrl
              ? "https://prokuroria-rks.org/uploads/" + autor.cvUrl
              : null,
            imageUrl:
              "https://prokuroria-rks.org/uploads/" +
              autor.imageUrl,
            postionName: autor.postionName,
            categoryName: autor.categoryName,
          }))
          .sort((a, b) => {
            if (!a.location) return 1;
            if (!b.location) return -1;
            return Number(a.location) - Number(b.location);
          });

        return (this.administrataEProkurorise = sorted);
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
  },
});